import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ampli } from '../../../ampli';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { Icon } from '../icon/Icon';

const SEARCH_TEXTS = [
  '존디어로 검색해 보세요 🦌',
  '모델명으로 검색해 보세요 🔎',
  '트랙터로 검색해 보세요 🚜',
  '이앙기로 검색해 보세요 🌱',
  '콤바인으로 검색해 보세요 🌾',
];

interface IOpenMarketSearchLandingButtonProps {
  pageType?: string;
}

export const OpenMarketSearchLandingButton = ({ pageType }: IOpenMarketSearchLandingButtonProps) => {
  const navigate = useNavigate();

  return (
    <SearchButtonContainer
      onClick={() => {
        ampli.pvmClickOpenMarketSearchLandingButton({
          page_type: pageType,
        });
        navigate(pageInfo.openMarketSearchPage.path);
      }}
    >
      <SearchTextWrapper>
        <CustomSwiper direction={'vertical'} slidesPerView={1} loop autoplay={{ delay: 3500 }} allowTouchMove={false}>
          {SEARCH_TEXTS.map((text) => (
            <SwiperSlide key={text}>
              <SearchText>{text}</SearchText>
            </SwiperSlide>
          ))}
        </CustomSwiper>
      </SearchTextWrapper>
      <Icon name={'Search'} size={'Large'} fill={'#858894'} />
    </SearchButtonContainer>
  );
};

const SearchButtonContainer = styled.div`
  height: 40px;

  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  padding: 8px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  cursor: pointer;
`;

const SearchTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  height: 100%;
  overflow: hidden;
`;

const CustomSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
`;

const SearchText = styled.span`
  display: flex;
  align-items: center;
  height: 100%;

  color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
  white-space: nowrap;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;
